<div class="login">
  You have been logged out.

  <div style="margin-top:20px">
    <button pButton class="p-button-outlined" [routerLink]="['']">Login to Signal Manager</button>
  </div>
</div>
